import { render, staticRenderFns } from "./BeForm.vue?vue&type=template&id=c3be342a&scoped=true"
import script from "./BeForm.vue?vue&type=script&lang=js"
export * from "./BeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3be342a",
  null
  
)

export default component.exports